import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { ErrorCodes, SuccessCodes } from "@/utils/getMessages";
interface UseHandleUrlStatusArgs {
  onSuccess: (success: SuccessCodes) => void;
  onError: (error: ErrorCodes) => void;
}

export function useHandleUrlStatus(args: UseHandleUrlStatusArgs) {
  const { onSuccess, onError } = args;
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const successParam = searchParams.get("success") as SuccessCodes;
    const errorParam = searchParams.get("error") as ErrorCodes;

    if (successParam) {
      onSuccess?.(successParam);
      // Remove query param from URL
      const newParams = new URLSearchParams(searchParams);
      newParams.delete("success");
      navigate({ search: newParams.toString() }, { replace: true });
    }

    if (errorParam) {
      onError?.(errorParam);
      const newParams = new URLSearchParams(searchParams);
      newParams.delete("error");
      navigate({ search: newParams.toString() }, { replace: true });
    }
  }, [searchParams, navigate, onSuccess, onError]);
}


